export default "__VITE_ASSET__794ed5a6__"